const NEXT_DATA_PREFIX = '/_next/data/';

/**
 * Extracts the page pathname from a Next.js data URL.
 * Example: `/_next/data/{buildId}/movies.json` → `/movies/`
 * Root page: `/_next/data/{buildId}/index.json` → `/`
 */
export function extractNextDataPagePathname(pathname: string): string | null {
    if (!pathname.startsWith(NEXT_DATA_PREFIX)) {
        return null;
    }

    const afterBuildId = pathname.slice(NEXT_DATA_PREFIX.length);
    const pagePathStart = afterBuildId.indexOf('/');
    if (pagePathStart === -1) {
        return null;
    }

    let pagePath = afterBuildId.slice(pagePathStart);
    if (pagePath.endsWith('.json')) {
        pagePath = pagePath.slice(0, -'.json'.length);
    }

    if (!pagePath.endsWith('/')) {
        pagePath = `${pagePath}/`;
    }

    // Next.js uses `index.json` for the root page; map `/index/` (and `/us/index/`, etc.) to `/`.
    if (pagePath.endsWith('/index/')) {
        return pagePath.slice(0, -'index/'.length) || '/';
    }

    return pagePath;
}
